// @flow
import type { SignUpIndividualActionType } from './actions';

export type SignUpIndividualStateType = {|
  isIndividualContactMediumsKo: boolean,
|};

const initialSignUpIndividualState: SignUpIndividualStateType = {
  isIndividualContactMediumsKo: false,
};

export const signUpIndividualReducer = (
  state: SignUpIndividualStateType = initialSignUpIndividualState,
  action: SignUpIndividualActionType
) => {
  switch (action.type) {
    case 'SIGNUP_SET_INDIVIDUAL_CONTACT_MEDIUMS_STATUS':
      return {
        ...state,
        isIndividualContactMediumsKo: action.payload.status,
      };
    default:
      return state;
  }
};
